/* Iniziali Atelier: funzioni pure (nessun DOM). Usate da lq-iniziali.js e lq-iniziali-cart.js, testate in tests/iniziali. */
(function () {
  'use strict';

  var MAX_LETTERS = 3;
  var MAX_NOTE = 200;
  var ID_LENGTH = 12;
  var ID_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789';
  var COLOR_IT = { oro: 'Oro', argento: 'Argento' };
  var PHOTO_IT = 'Foto preliminare';

  function sanitizeInitials(raw) {
    var text = String(raw == null ? '' : raw);
    if (text.normalize) text = text.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return text.toUpperCase().replace(/[^A-Z]/g, '').slice(0, MAX_LETTERS);
  }

  /* Istruzioni per l'applicazione: una riga sola (spazi e a capo compressi), al massimo 200 caratteri,
     senza < > perché il tema stampa le proprietà del carrello senza escape. */
  function sanitizeNote(raw) {
    return String(raw == null ? '' : raw).replace(/[<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, MAX_NOTE);
  }

  function newAtelierId() {
    var bytes = [];
    var cryptoObj = typeof crypto !== 'undefined' ? crypto : null;
    if (cryptoObj && cryptoObj.getRandomValues) {
      bytes = Array.prototype.slice.call(cryptoObj.getRandomValues(new Uint8Array(ID_LENGTH)));
    } else {
      for (var i = 0; i < ID_LENGTH; i++) bytes.push(Math.floor(Math.random() * 256));
    }
    return bytes.map(function (b) { return ID_CHARS.charAt(b % ID_CHARS.length); }).join('');
  }

  function propertiesFromEntries(entries) {
    var out = {};
    entries.forEach(function (entry) {
      var match = /^properties\[([^\]]+)\]$/.exec(entry[0]);
      if (!match) return;
      var key = match[1];
      if (key === '__proto__' || key === 'constructor' || key === 'prototype') throw new Error('Proprietà non valida');
      if (Object.prototype.hasOwnProperty.call(out, key)) throw new Error('Proprietà duplicata: ' + key);
      if (typeof entry[1] !== 'string') throw new Error('Proprietà file non supportata');
      out[key] = entry[1];
    });
    return out;
  }

  /* Le proprietà del capo vanno in questo ordine: _Laboratorio (italiano), chiavi visibili tradotte, _atelier_id.
     Istruzioni e foto preliminare compaiono solo se la cliente le ha scelte. */
  function buildCartItems(opts) {
    var labels = opts.labels;
    var note = sanitizeNote(opts.note);
    var parent = {};
    var lab = [opts.initials, COLOR_IT[opts.color], opts.position.nomeIt];
    if (opts.photo) lab.push(PHOTO_IT);
    parent._Laboratorio = lab.join(' · ');
    parent[labels.initials] = opts.initials;
    parent[labels.color] = labels.colorName[opts.color];
    parent[labels.position] = opts.position.nome;
    if (note) parent[labels.note] = note;
    if (opts.photo) parent[labels.photo] = labels.yes;
    parent[labels.terms] = labels.accept;
    parent._atelier_id = opts.atelierId;
    // Keep properties produced by the product form/app. The initials module
    // never creates Zepto keys; it carries through values already supplied.
    var extra = opts.additionalProperties || {};
    var extraKeys = Object.keys(extra);
    if (extraKeys.length) {
      var owned = Object.keys(parent);
      extraKeys.forEach(function (key) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype' || key === '_atelier_fields') {
          throw new Error('Proprietà di personalizzazione non valida');
        }
        if (Object.prototype.hasOwnProperty.call(parent, key)) {
          throw new Error('Proprietà di personalizzazione in conflitto: ' + key);
        }
        if (typeof extra[key] !== 'string') throw new Error('Valore di personalizzazione non valido');
        parent[key] = extra[key];
      });
      // Records exactly the translated fields to remove later, even if the
      // shopper changes language before removing the initials in the cart.
      parent._atelier_fields = JSON.stringify(owned);
    }
    return [
      { id: opts.variantId, quantity: 1, properties: parent },
      { id: opts.initialsVariantId, quantity: 1, parent_id: opts.variantId, properties: { _atelier_id: opts.atelierId } }
    ];
  }

  /* Lettere affiancate: ogni PNG ha un margine trasparente, lo spazio fra lettere è in diametri di pietra. */
  function layoutLetters(text, metrics, gapDiametri, scale) {
    var items = [];
    var x = 0;
    var height = 0;
    var gap = gapDiametri * metrics.diametro_px;
    for (var i = 0; i < text.length; i++) {
      var size = metrics.lettere[text.charAt(i)];
      if (!size) continue;
      if (items.length) {
        var prev = items[items.length - 1];
        x = prev.x + (prev.w / scale - 2 * metrics.margine_px + gap) * scale;
      }
      items.push({ letter: text.charAt(i), x: x, y: 0, w: size[0] * scale, h: size[1] * scale });
      height = Math.max(height, size[1] * scale);
    }
    if (!items.length) return { items: [], width: 0, height: 0 };
    var last = items[items.length - 1];
    return { items: items, width: last.x + last.w, height: height };
  }

  /* Le tute due pezzi sono pacchetti (bundle): Shopify rifiuta la riga annidata (422). Ripiego: stesse righe senza
     parent_id, legate da _atelier_id (il carrello le riconosce e le controlla con findOrphans). Ordine invertito:
     il carrello mostra per prima l'ultima riga aggiunta, così il capo resta sopra e le Iniziali sotto. */
  function withoutNesting(items) {
    return items.slice().reverse().map(function (item) {
      var out = {};
      Object.keys(item).forEach(function (k) { if (k !== 'parent_id') out[k] = item[k]; });
      return out;
    });
  }

  /* Righe Iniziali non annidate dello stesso capo: «Togli le iniziali» le deve togliere esplicitamente. */
  function unnestedChildKeys(cartItems, parent, initialsVariantId) {
    var id = parent.properties && parent.properties._atelier_id;
    if (!id) return [];
    return cartItems.filter(function (item) {
      return item.key !== parent.key && !item.parent_relationship &&
        Number(item.variant_id) === Number(initialsVariantId) &&
        item.properties && item.properties._atelier_id === id;
    }).map(function (item) { return item.key; });
  }

  function isChild(item, initialsVariantId) {
    return Number(item.variant_id) === Number(initialsVariantId) || !!item.parent_relationship;
  }

  /* Righe da correggere: capo con _atelier_id senza figlia, figlia senza capo, figlia con quantità diversa dal capo. */
  function findOrphans(cartItems, initialsVariantId) {
    var parents = {};
    var children = {};
    cartItems.forEach(function (item) {
      var id = item.properties && item.properties._atelier_id;
      if (!id) return;
      if (isChild(item, initialsVariantId)) children[id] = item;
      else parents[id] = item;
    });
    var result = { orphanParents: [], orphanChildren: [], wrongQuantity: [] };
    Object.keys(parents).forEach(function (id) {
      if (!children[id]) result.orphanParents.push(parents[id].key);
    });
    Object.keys(children).forEach(function (id) {
      var child = children[id];
      if (!parents[id]) result.orphanChildren.push(child.key);
      else if (child.quantity !== parents[id].quantity) {
        result.wrongQuantity.push({ key: child.key, quantity: parents[id].quantity });
      }
    });
    return result;
  }

  /* Il pannello modifica una bozza; lo stato confermato cambia solo con commitDraft. */
  function draftFrom(state) {
    return { initials: state.initials, color: state.color, point: state.point, note: state.note || '', photo: !!state.photo };
  }

  function commitDraft(state, draft) {
    return { initials: draft.initials, color: draft.color, point: draft.point, note: draft.note, photo: draft.photo, confirmed: true };
  }

  /* Cosa fare all'invio del form: 'pass' (lascia fare al tema), 'block' (aggiunta già in corso), 'intercept'. */
  function submitDecision(s) {
    if (!s.confirmed || !s.initials || !s.variantId) return 'pass';
    if (s.pending) return 'block';
    return 'intercept';
  }

  /* Capo personalizzato → capo semplice: prima si aggiunge il semplice, poi si toglie il personalizzato,
     così un'aggiunta fallita non fa sparire il capo. */
  function plainReplacementOps(item) {
    var add = { type: 'add', id: Number(item.variant_id), quantity: item.quantity || 1 };
    var props = item.properties || {};
    if (props._atelier_fields) {
      var fields = JSON.parse(props._atelier_fields);
      if (!Array.isArray(fields) || fields.some(function (k) { return typeof k !== 'string'; })) {
        throw new Error('Campi iniziali non validi');
      }
      var remaining = {};
      Object.keys(props).forEach(function (key) {
        if (key !== '_atelier_fields' && fields.indexOf(key) === -1) remaining[key] = props[key];
      });
      if (Object.keys(remaining).length) add.properties = remaining;
    } else if (Object.keys(props).some(function (k) { return /^_pplr|^_pc_pricing|^Preview$|^Stella /.test(k); })) {
      // Existing mixed data without field ownership cannot be safely stripped.
      throw new Error('Rimozione iniziali non disponibile per questa configurazione');
    }
    if (item.selling_plan_allocation) add.selling_plan = item.selling_plan_allocation.selling_plan.id;
    return [
      add,
      { type: 'change', key: item.key, quantity: 0 }
    ];
  }

  var AUTOFIX_KEY = 'lqInizialiAutofixAt';
  var AUTOFIX_GAP_MS = 30000;

  /* Al massimo una correzione automatica ogni 30 s, ricordata tra ricariche (niente ricariche a catena). */
  function autoFixAllowed(store, now) {
    if (!store) return true;
    var last = Number(store.getItem(AUTOFIX_KEY) || 0);
    if (last && now - last < AUTOFIX_GAP_MS) return false;
    store.setItem(AUTOFIX_KEY, now);
    return true;
  }

  /* Foto del colore scelto: se la variante ha un punto per quella posizione ne prende foto e coordinate,
     altrimenti resta il punto base. Il nome della posizione (cliente e laboratorio) è sempre quello del punto base. */
  var COLOUR_FIELDS = ['foto', 'x', 'y', 'altezza', 'rotazione'];
  function pointForVariant(points, colours, index, variantId) {
    var base = points[index] || points[0];
    var id = Number(variantId);
    var list = colours || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].varianti.indexOf(id) === -1) continue;
      var override = list[i].punti[index];
      if (!override || !points[index]) return base;
      var out = {};
      Object.keys(base).forEach(function (k) { out[k] = base[k]; });
      COLOUR_FIELDS.forEach(function (k) { if (override[k] != null) out[k] = override[k]; });
      return out;
    }
    return base;
  }

  /* «Conferma le iniziali» si accende solo con almeno una lettera e condizioni accettate. */
  function canConfirm(draft, termsAccepted) {
    return !!(draft && draft.initials) && termsAccepted === true;
  }

  var api = {
    canConfirm: canConfirm,
    pointForVariant: pointForVariant,
    withoutNesting: withoutNesting,
    unnestedChildKeys: unnestedChildKeys,
    draftFrom: draftFrom,
    commitDraft: commitDraft,
    submitDecision: submitDecision,
    plainReplacementOps: plainReplacementOps,
    autoFixAllowed: autoFixAllowed,
    sanitizeInitials: sanitizeInitials,
    sanitizeNote: sanitizeNote,
    newAtelierId: newAtelierId,
    buildCartItems: buildCartItems,
    propertiesFromEntries: propertiesFromEntries,
    layoutLetters: layoutLetters,
    findOrphans: findOrphans
  };

  if (typeof window !== 'undefined' && window) {
    window.LqIniziali = window.LqIniziali || {};
    Object.keys(api).forEach(function (k) { window.LqIniziali[k] = api[k]; });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
